import React, { useEffect, useState } from 'react'

import { Breadcrumb, Button, Card, Form, Icon, notification, Row, Typography } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import CustomInput from '../../components/CustomInput/customInput'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import { RULES, validRule } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateLocationType = function ({ match, history }) {
  const defaultFormValues = { active: true }
  const [formLayout] = useState('vertical')

  // Params url
  const { id } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})

  const form = {
    initialValues: formValues,
    // Update-validation-rules-marker
    yupValidationUpdate: yup.object().shape({
      // Update-validation-rules-body-marker
      name: yup
        .string()
        .matches(/[a-zA-Z]+/g, 'Preencha um nome válido')
        .max(60)
        .typeError('Preencha um nome válido')
        .nullable()
        .typeError('must be string')
    }),

    // Create-validation-rules-marker
    yupValidationCreate: yup.object().shape({
      // Create-validation-rules-body-marker
      name: yup
        .string()
        .matches(/[a-zA-Z]+/g, 'Preencha um nome válido')
        .max(60)
        .typeError('Preencha um nome válido')
        .nullable()
        .required(getMessage('isRequired', getMessage('memberTypeDescription')))
    }),

    onSubmit: async (values) => {
      console.tron.log('submit values', values)
      if (!id) {
        const data = {
          ...values
        }
        createLocationTypes(data)
      } else {
        const payload = {
          data: {
            name: values.name,
            active: values.active
          },
          id
        }
        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }

        updateLocationTypes(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.MEMBER_TYPE) // Não deixa acessar a tela

    if (!hasAccess) {
      return history.push('/home')
    }

    if (id) {
      getLocationTypesByID(id)
    } else {
      setFormValues({})
    }

    // Use-effect-mount-marker
    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues(defaultFormValues)
    }
  }, [id])

  // Api requests
  async function createLocationTypes(data) {
    try {
      await request(api.createLocationTypes(data))
      notification.success({
        description: getMessage('successStoreTypes'), // SuccessStoreTypes
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function getLocationTypesByID(typeId) {
    try {
      const response = await request(api.getLocationTypesByID(typeId))
      setFormValues({
        ...response
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateLocationTypes(payload) {
    try {
      const { id, data } = payload
      await request(api.updateLocationTypes(id, data))
      notification.success({
        description: getMessage('successupdateTypes'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id ? getMessage('updateLocationTypes') : getMessage('createLocationTypes')
  }

  function renderHeader(submitForm) {
    const hasAccess = id ? validRule(RULES.MEMBER_TYPE) : validRule(RULES.MEMBER_TYPE)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.push('/')}>
              <Icon
                type="home"
                theme="filled"
                style={{ fontSize: '16px', color: '#263447' }}
                onClick={() => history.push('/')}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => history.push(`/locationTypes/list`)}>Tipo de Local</Breadcrumb.Item>
            <Breadcrumb.Item>
              {id ? getMessage('updateLocationTypes') : getMessage('createLocationTypes')}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({
              ...formValues,
              [field]: value
            })
            return setFieldValue(field, value)
          }

          return (
            <Form className="locationTypes-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <Typography.Title className="default-header-title" level={3}>
                  {getTitle()}
                </Typography.Title>
                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    unCheckedChildren={getMessage('label.inactive')}
                    checkedChildren={getMessage('label.active')}
                  />
                </Row>
                <Row type="flex" justify="start">
                  <CustomInput
                    field="name"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default CreateLocationType
